module.exports = __webpack_public_path__ + "img/login-05.f9c37699.jpg";